import emptyResult from './empty_result.svg'
import searchIcon from './ic_search.svg'
import searchNotFound from './ic_searchnotfound.svg'
import leadTraderComing from './leadTraderComing.svg'
import Crown from './Crown.svg'

export const SVGs = {
    emptyResult,
    searchIcon,
    searchNotFound,
    leadTraderComing,
    Crown,
}
